import SurveyDashboard from './SurveyDashboard';
export default SurveyDashboard;
